import _ from 'lodash';
import React, { Component } from "react";
import ReportsService from '../utils/ReportsService';
class ReportingSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: { view: "list", assigned: "" },
      textFilter: '',
    };
    this.debouncedFetchItems = _.debounce(() => this.fetchItems(), 300)
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchItems)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view }, this.fetchItems)
    }
  }

  fetchItems() {
    ReportsService.sales({ view: this.state.view, text_filter: this.state.textFilter }).then(response => {
      this.setState({ loadingInProgress: false, data: response })
    })
  }

  handleTextFilterChange = (event) => {
    let value = event.target.value;
    this.setState({ textFilter: value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }, this.debouncedFetchItems)
  }

  render() {
    if (!this.state.data) return null

    const { data } = this.state;
    const { totals } = data

    return (
      <div>
        <div className='row'>
          <div className="col-sm-3">
            <div style={{ margin: '0 0 10px 0' }}>
              <input type="text" placeholder="Search" className='form-control input-sm' value={this.state.textFilter} onChange={this.handleTextFilterChange} />
            </div>
          </div>

          <div className="col-sm-3">
            Filter
          </div>
          <div className="col-sm-3">
            Filter
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div style={{ width: '100%', height: 600 }}>
              {Object.keys(totals).map((user) => {
                console.log(user)
                return (<>
                  <h4>{user}</h4>
                  <table className='table' style={{ width: 400 }}>
                    <tbody>
                      {Object.keys(totals[user]).map((t) => {
                        return <tr key={t}>
                          <td>{t}</td>
                          <td>{totals[user][t]}</td>
                        </tr>
                      })
                      }
                    </tbody>
                  </table>
                </>)
              }
              )}
            </div>
          </div>
        </div>

      </div>
    );
  }
}
export default ReportingSales
